<template>
  <div>
    <PageAllow controller="AllianceBusinesses" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="keyword"
                v-model="alliancesKeyword"
                @text="alliancesKeywordText($event)"
                :label="
                  $t('Alliances.alliancesKeyword', [$consts.allianceName()])
                "
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <v-btn
                small
                color="success"
                dark
                @click.stop="submit()"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fas fa-save</v-icon>
                {{ $t("AnnouncementShop.submit") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherDistrict
                    v-model="districtSelected"
                    :label="
                      $t('Alliances.Fields.alliance_district', [
                        $consts.allianceName(),
                      ])
                    "
                  />
                </v-col>
                <v-col cols="12" sm="6" md="8">
                  <div
                    class="caption grey--text input-chip-group-label"
                    :class="
                      $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                    "
                  >
                    {{ $t("Alliances.Fields.status") }}
                  </div>
                  <v-chip-group
                    v-model="alliancesStatus"
                    column
                    multiple
                    class="mx-1"
                  >
                    <v-chip
                      small
                      label
                      filter
                      class="mx-1"
                      color="primary"
                      text-color="white"
                      :key="1"
                      :value="1"
                      >{{ $t("Alliances.status.on") }}</v-chip
                    >
                    <v-chip
                      small
                      label
                      filter
                      class="mx-1"
                      color="grey"
                      text-color="white"
                      :key="0"
                      :value="0"
                      >{{ $t("Alliances.status.off") }}</v-chip
                    >
                  </v-chip-group>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="alliancesItems"
            :loading="loading"
            multi-sort
            class="elevation-2 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.choose>
              <v-checkbox
                class="mt-2 mb-n3"
                color="primary"
                :indeterminate="
                  alliancesItems.find((detail) => detail.choose != chooseAll)
                    ? true
                    : false
                "
                v-model="chooseAll"
                :true-value="1"
                :false-value="0"
              >
                <template v-slot:label>
                  <span class="caption ms-n2">
                    {{ $t("CRUD.chooseAll") }}
                  </span>
                </template>
              </v-checkbox>
            </template>

            <template v-slot:item.choose="{ item }">
              <div class="d-flex mt-n2 mb-n3">
                <v-checkbox
                  color="primary"
                  v-model="item.choose"
                  :true-value="1"
                  :false-value="0"
                  :disabled="item.disabled"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t(item.choose ? "CRUD.choosed" : "CRUD.unchoose") }}
                    </span>
                  </template>
                </v-checkbox>
              </div>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Announcement from "@/api/announcement";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherDistrict from "@/components/plugins/SearcherDistrict";
import Alliances from "@/api/alliance_businesses";

const defaultOptions = {
  keyword: "",
  status: [0, 1],
  district_id: "",
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    SearcherDistrict,
  },

  data: () => ({
    options: JSON.parse(JSON.stringify(defaultOptions)),
    alliances: [],
    chooseAll: 0,
    alliancesKeyword: "",
    alliancesStatus: [0, 1],
    push_alliance_ids: [],
    districtSelected: null,
    districtSelectedIds: [],
  }),

  computed: {
    alliancesItems() {
      return this.abc();
    },
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.customerMaintenance"),
          disabled: false,
          href: "/qacenter",
        },
        {
          text: i18n.t("Nav.announcement"),
          disabled: false,
          href: "/announcement",
        },
        {
          text: i18n.t("Nav.announcementAlliances", [
            this.$consts.allianceName(),
          ]),
          disabled: true,
        },
      ];
    },
    headers() {
      return [
        {
          text: i18n.t("Alliances.Fields.alliance_business_code", [
            this.$consts.allianceName(),
          ]),
          align: "start",
          sortable: false,
          value: "alliance_business_code",
        },
        {
          text: i18n.t("Alliances.Fields.alliance_business_name", [
            this.$consts.allianceName(),
          ]),
          align: "start",
          sortable: false,
          value: "alliance_business_name",
        },
        {
          text: i18n.t("Alliances.Fields.alliance_district", [
            this.$consts.allianceName(),
          ]),
          align: "start",
          sortable: false,
          value: "district.name",
        },
        {
          text: i18n.t("CRUD.chooseAll"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "choose",
        },
      ];
    },
    ...mapState(["loading"]),
  },
  mounted() {
    Announcement.fetchOne(this.$route.params.id).then(
      function (response) {
        if (response.data.status.isOK()) {
          this.push_alliance_ids = response.data.announcement.push_alliance_ids;
        }
      }.bind(this)
    );
    this.getAlliancesFromAPI();
  },
  methods: {
    resetSearch() {
      this.districtSelected = null;
      [this.$refs.keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.abc();
    },

    abc() {
      return this.alliances.filter(
        (e) =>
          ((this.alliancesStatus.length &&
            this.alliancesStatus.find((flg) => flg == e.status) != undefined) ||
            !this.alliancesStatus.length) &&
          ((this.districtSelected &&
            this.districtSelectedIds.find((detail) => {
              return detail == e.district.id;
            })) ||
            !this.districtSelected) &&
          ((this.alliancesKeyword &&
            e.alliance_business_name.indexOf(this.alliancesKeyword) > -1) ||
            e.alliance_business_code.indexOf(this.alliancesKeyword) > -1 ||
            !this.alliancesKeyword)
      );
    },
    alliancesKeywordText(e) {
      this.alliancesKeyword = e;
    },

    getAlliancesFromAPI() {
      Alliances.fetchAll(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            var alliances = response.data.alliance_businesses;
            alliances.forEach((detail) => {
              detail.choose = 0;
            });
            this.alliances = alliances;
            this.alliances.map((v) => {
              if (this.push_alliance_ids.includes(v.id)) {
                v.choose = 1;
              }
              return v;
            });
          }
        }.bind(this)
      );
    },

    submit() {
      let alliance_ids = this.alliances
        .filter((v) => !!v.choose)
        .map((v) => v.id);

      var data = [];
      data.push({
        id: this.$route.params.id,
        alliance_ids: alliance_ids,
      });
      Announcement.pushShop(data[0]).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$router.push("/announcement");
          }
        }.bind(this)
      );
    },
    // 查询分组
    getdistrictSelectedIds(item, ids = []) {
      item.forEach((e) => {
        ids.push(e.id);
        if (e.districts && e.districts.length > 0) {
          this.getdistrictSelectedIds(e.districts, ids);
        }
      });
      return ids;
    },
  },

  watch: {
    push_alliance_ids: {
      deep: true,
      handler() {
        this.alliances.map((v) => {
          if (this.push_alliance_ids.includes(v.id)) {
            v.choose = 1;
          }
          return v;
        });
      },
    },

    chooseAll: {
      handler() {
        this.alliancesItems.forEach(
          function (e) {
            e.choose = this.chooseAll ? 1 : 0;
          }.bind(this)
        );
      },
    },
    districtSelected: {
      handler() {
        var arr = [];
        arr.push(this.districtSelected);
        if (this.districtSelected) {
          this.districtSelectedIds = this.getdistrictSelectedIds(arr);
        }
      },
    },
  },
};
</script>

<style>
</style>